import { Input, Directive } from '@angular/core';

@Directive()
export abstract class PartialBaseComponent {
  @Input() disabled: boolean = false;
}
